import { render, staticRenderFns } from "./SpecialPageDetail.vue?vue&type=template&id=500eccf7&scoped=true&"
import script from "./SpecialPageDetail.vue?vue&type=script&lang=js&"
export * from "./SpecialPageDetail.vue?vue&type=script&lang=js&"
import style0 from "./SpecialPageDetail.vue?vue&type=style&index=0&id=500eccf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500eccf7",
  null
  
)

export default component.exports